import type { HomeCardsConfig } from '../components/home-cards.tsx';
import { FACILITIES_CARDS } from './facilities/home-cards.ts';
import { FINANCE_CARDS } from './finance/home-cards.ts';
import { FPA_CARDS } from './fpa/home-cards.ts';
import { IT_CARDS } from './it/home-cards.ts';
import { LEGAL_CARDS } from './legal/home-cards.ts';
import { MASTERDATA_CARDS } from './masterdata/home-cards.ts';

/** Cartões de cada departamento, pelo id da área em navigation.ts (ADR 0097). */
export const DEPARTMENT_CARDS: Record<string, HomeCardsConfig | undefined> = {
  facilities: FACILITIES_CARDS,
  finance: FINANCE_CARDS,
  fpa: FPA_CARDS,
  it: IT_CARDS,
  legal: LEGAL_CARDS,
  system: MASTERDATA_CARDS,
};
